import React from "react";
import "./cta.scss";

const Cta = ({ varient, title, subtitle, children }) => {
  return (
    <div className={varient ? `cta_wrap ${varient}` : "cta_wrap"}>
      <div className="cta_info">
        <h2 className="cta_title">{title}</h2>
        <p className="cta_subtitle">{subtitle}</p>
      </div>
      <div className="cta_btn">{children}</div>
    </div>
  );
};
Cta.defaultProps = {
  varient: "style1",
};
export default Cta;
